// import React, { Suspense } from 'react';

// import {
//   createBrowserRouter,
//   Outlet,
//   Navigate,
//   BrowserRouter, Routes, Route
// } from 'react-router-dom';
// import HelmetHead from 'components/HelmetHead';
// import Home from './pages/Home';
// import LoaderIcon from 'components/LoaderIcon/LoaderIcon';
// import { ProductsProvider } from './context/ProductsContext';


// import './styles/global.scss';

// const Layout = ({ type }) => {
//   return (
//     <ProductsProvider type={type}>
//       <Outlet />
//     </ProductsProvider>
//   );
// };


// const Product = React.lazy(() => import('./pages/Product/Product'));


// const router = createBrowserRouter([
//   {
//     path: '/',
//     element: <Layout type="best sellers" />,
//     children: [
//       {
//         path: '/',
//         element: <Home />,
//       },
//       {
//         path: 'product/:id',
//         element: <Product />,
//       },
//       {
//         path: '*',
//         element: <Navigate to="/" replace />,
//       },
//     ],
//   },
// ]);

// function App() {
//   return (
//     <BrowserRouter basename="/paintings">
//       <HelmetHead />
//       <Suspense fallback={<LoaderIcon />}>
//         <Routes>
//           <Route path="/" element={<Layout type="best sellers" />}>
//             <Route index element={<Home />} />
//             <Route path="product/:id" element={<Product />} />
//             <Route path="*" element={<Navigate to="/" replace />} />
//           </Route>
//         </Routes>
//       </Suspense>
//     </BrowserRouter>
//   );
// }

// export default App;

import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import HelmetHead from 'components/HelmetHead';
import Home from './pages/Home';
import LoaderIcon from 'components/LoaderIcon/LoaderIcon';
import { ProductsProvider } from './context/ProductsContext';

import './styles/global.scss';

const Layout = ({ type }) => {
  return (
    <ProductsProvider type={type}>
      <Outlet /> 
    </ProductsProvider>
  );
};

const Product = React.lazy(() => import('./pages/Product/Product'));

function App() {
  return (
    <BrowserRouter basename="/paintings">
      <HelmetHead />
      <Suspense fallback={<LoaderIcon />}>
        <Routes>
          <Route path="/" element={<Layout type="best sellers" />}>
            <Route index element={<Home />} />
            <Route path="product/:id" element={<Product />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
